export const OPERATION_TITLES: Record<string, string> = {
  ServiceCenterMakesSync: 'Loading makes',
  VehiclesInDmsRecalculation: 'Recalculating vehicles in DMS',
};

export const OPERATION_COMPLETED_MESSAGES: Record<string, string> = {
  ServiceCenterMakesSync: 'Makes loaded. The recall data is up to date.',
  VehiclesInDmsRecalculation: 'Vehicles in DMS recalculated.',
};

export const STAGE_LABELS: Record<string, string> = {
  WaitingForLock: 'Waiting for another recall operation to finish',
  LoadingRecallData: 'Loading recall data',
  Planning: 'Planning',
  CountingVehiclesInDms: 'Counting vehicles in DMS',
  Saving: 'Saving',
};

export const DEFAULT_OPERATION_TITLE = 'Recall sync';
export const DEFAULT_COMPLETED_MESSAGE = 'The recall data is up to date.';
export const DEFAULT_FAILED_MESSAGE = 'The recall operation failed. Please try again.';
export const CANCELLED_MESSAGE = 'The recall operation was cancelled.';
